import React, { useEffect } from "react";
import styled from "styled-components";
import Task from "./Task";
import { Droppable } from "react-beautiful-dnd";

const Container = styled.div`
  margin: 8px;
  border: ${(props) =>
    ["column-1", "column-8"].includes(props.is_first)
      ? "3px solid #262b40"
      : "1px solid lightgray"};
  border-radius: 2px;
  width: ${(props) => (props.is_first == "column-8" ? "12vw" : "25vw")};
  display: flex;
  flex-direction: column;
`;
const Title = styled.h3`
  padding: 8px;
`;
const TaskList = styled.div`
  padding: 8px;
  flex-grow: 1;
  background-color: "white";
`;
export default function (props) {
  const { column, tasks } = props;
  useEffect(() => {
    console.log("column", props.column, props.tasks);
  }, []);
  return (
    <Container is_first={column.id}>
      <Title>
        {" "}
        {column.title}{" "}
        {column.id !== "column-8" && "( " + column.tasksIds.length + " )"}
      </Title>
      <Droppable droppableId={column.id}>
        {(provided) => (
          <TaskList ref={provided.innerRef} {...provided.droppableProps}>
            {tasks.map((task, index) => (
              <Task key={task?.id} task={task} index={index} />
            ))}
            {provided.placeholder}
          </TaskList>
        )}
      </Droppable>
    </Container>
  );
}
